<template>
    <facility-landing-buttons />
</template>

<script setup lang="ts">
import { definePageMeta } from '#imports'
import FacilityLandingButtons from '~/components/Layouts/FacilityLandingButtons.vue'

definePageMeta({
    // Public landing content follows the organization's shared search policy.
    searchIndexing: 'public',
    layout: 'org'
})
</script>
